import { useState } from "react";
import { Button, FileUploaderButton, InlineLoading } from "@carbon/react";
import { Close } from "@carbon/icons-react";
import i18next from "../../../../i18n";
import { FileType } from "../../../../utils";
import { useFileInputUploader } from "../../../../hooks";

export type LineFile = {
  fileName: string;
  name: string;
  fileURL: string;
  type: string;
};

type LineFilesUploaderProps = {
  files: LineFile[];
  onAdd: (file: LineFile) => void;
  onRemove: (index: number) => void;
};

// Per-line, multi-file attachments for the launch flow (Servicios #4).
const LineFilesUploader = ({
  files,
  onAdd,
  onRemove,
}: LineFilesUploaderProps) => {
  // Bumping the key remounts the Carbon FileUploaderButton so it clears the
  // just-uploaded file name and is ready for the next attachment.
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const { mutate: uploadFile, isPending } = useFileInputUploader();

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    uploadFile(file, {
      onSuccess: (url: string) => {
        onAdd({
          fileName: file.name,
          name: file.name,
          fileURL: url,
          type: FileType.ATTACHMENT,
        });
        setFileInputKey(Date.now());
      },
    });
  };

  return (
    <div className="order-col-full">
      {isPending ? (
        <InlineLoading description={i18next.t("cta.attach")} />
      ) : (
        <FileUploaderButton
          key={fileInputKey}
          buttonKind="tertiary"
          labelText={`${i18next.t("cta.attach")} ${i18next.t(
            "tenders.form.additionalDocument"
          )}`}
          disableLabelChanges
          disabled={isPending}
          onChange={handleSelect}
        />
      )}
      {files?.length > 0 && (
        <div>
          {files.map((file, index) => (
            <div key={`${file.fileURL}-${index}`} className="order-file-row">
              <span>{file.fileName || file.name}</span>
              <Button
                kind="ghost"
                size="sm"
                hasIconOnly
                renderIcon={Close}
                iconDescription={i18next.t("cta.remove")}
                onClick={() => onRemove(index)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LineFilesUploader;
